import { Injectable } from '@angular/core';
import { timer } from 'rxjs';
import { Subject, Subscription } from 'rxjs-compat';
import { takeUntil } from 'rxjs/operators';
import { UserModel } from 'src/models/user.model';
import { ShareDataService } from '../providers/sharedata.service';
import { CorrectYeKeService } from './correctyeke.service';
import { RestApiService } from './rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private redirectUrl = '/';
  private loginUrl = '/login';
  private ordermanagementUrl = '/ordermanagement';
  public isloggedIn = false;
  public loggedInUser: UserModel;
  public users: UserModel[];
  public destroy$ = new Subject<void>();
  public timerSubscription: Subscription;
  constructor(private api: RestApiService<any>, private share: ShareDataService) {

  }
  isUserAuthenticated(username: string, password: string): boolean {
    let user: any;
    user = this.users.filter(
      u => CorrectYeKeService.getCorrectYeKe(u.name) === CorrectYeKeService.getCorrectYeKe(username) &&
        CorrectYeKeService.getCorrectYeKe(u.password) === CorrectYeKeService.getCorrectYeKe(password)
    );
    if (user.length !== 0) {
      this.isloggedIn = true;
      this.loggedInUser = user[0];
    } else {
      this.isloggedIn = false;
    }
    return this.isloggedIn;
  }
  isUserLoggedIn(): boolean {
    return this.isloggedIn;
  }
  getRedirectUrl(): string {
    return this.redirectUrl;
  }
  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }
  getLoginUrl(): string {
    return this.loginUrl;
  }
  getLoggedInUser(): UserModel {
    return this.loggedInUser;
  }
  getOrdermanagementUrl(): string {
    return this.ordermanagementUrl;
  }
  logoutUser(): void {
    this.isloggedIn = false;
  }
  getDiffDays(sDate, eDate) {
    var startDate = new Date(sDate);
    var endDate = new Date(eDate);
    var Time = endDate.getTime() - startDate.getTime();
    return Time / (1000 * 3600 * 24);
  }
  onUserActivity() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
    this.startTimer();
  }
  startTimer() {
    this.timerSubscription = timer(20 * 60 * 1000)
      .pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        window.location.reload();
      });
  }
}
